import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=36420e2d&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=36420e2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36420e2d",
  null
  
)

export default component.exports